/**
 * Eikogakuen2 Kindergarten - Main JavaScript
 */

// Import modules
// import './grid-overlay'; // DEV ONLY: design grid overlay (keys: G / F / H). Keep commented on production.
import './navigation';
import './tabs';
import './accordion';
import './footer';
import initYearFilter from './year-filter';
import initNewsFilter from './news-filter';
import initVideoModal from './video-modal';

// DOM ready
document.addEventListener('DOMContentLoaded', () => {
  initYearFilter();
  initNewsFilter();
  initVideoModal();

  // ── Reusable card slider ───────────────────────────────────────
  const initSlider = (cfg) => {
    const track = document.getElementById(cfg.trackId);
    const dotsWrap = document.getElementById(cfg.dotsId);
    const wrap = track && track.closest(cfg.wrapSelector);
    if (!track || !wrap) return;

    const cards = Array.from(track.children);
    const prevBtn = wrap.querySelector(cfg.prevSelector);
    const nextBtn = wrap.querySelector(cfg.nextSelector);
    const dotClass = cfg.dotClass || 'sp-dot';
    let current = 0;

    const getSPV = () => window.innerWidth >= 1200 ? 3.5 : window.innerWidth >= 768 ? 2.2 : 1.2;

    const getCardW = () => {
      if (!cards.length) return 0;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.gap) || 24;
      return cards[0].offsetWidth + gap;
    };

    const maxIndex = () => Math.max(0, cards.length - Math.floor(getSPV()));

    const buildDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const total = maxIndex() + 1;
      for (let i = 0; i < total; i++) {
        const dot = document.createElement('button');
        dot.className = dotClass + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `スライド ${i + 1}`);
        dot.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(dot);
      }
    };

    const updateDots = () => {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.' + dotClass).forEach((d, i) => {
        d.classList.toggle('is-active', i === current);
      });
    };

    const goTo = (index) => {
      current = Math.max(0, Math.min(index, maxIndex()));
      track.style.transform = `translateX(-${current * getCardW()}px)`;
      updateDots();
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= maxIndex();
    };

    const toggleNav = () => {
      const needsSlider = cards.length > Math.floor(getSPV());
      if (prevBtn) prevBtn.style.display = needsSlider ? '' : 'none';
      if (nextBtn) nextBtn.style.display = needsSlider ? '' : 'none';
      if (dotsWrap) dotsWrap.style.display = needsSlider ? '' : 'none';
    };

    buildDots();
    toggleNav();
    goTo(0);

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    window.addEventListener('resize', () => { buildDots(); toggleNav(); goTo(0); });
  };

  // Support Programs Slider (home)
  initSlider({
    trackId: 'supportProgramsTrack',
    dotsId: 'supportProgramsDots',
    wrapSelector: '.support-programs__slider-wrap',
    prevSelector: '.support-programs__nav--prev',
    nextSelector: '.support-programs__nav--next',
    dotClass: 'sp-dot',
  });

  // Parent Notices Slider
  initSlider({
    trackId: 'parentNoticesTrack',
    dotsId: 'parentNoticesDots',
    wrapSelector: '.parents-notices__slider-wrap',
    prevSelector: '.parents-notices__nav--prev',
    nextSelector: '.parents-notices__nav--next',
    dotClass: 'pn-dot',
  });

  // Support finder accordion
  document.querySelectorAll('.support-finder__item[data-accordion]').forEach((item) => {
    const trigger = item.querySelector('.support-finder__trigger');
    const content = item.querySelector('.support-finder__content');
    if (!trigger || !content) return;

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen);
      content.setAttribute('aria-hidden', !isOpen);
      content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0';
    });
  });
});
